<div class="transaction-setting-container flex flex-row flex-1-0-100">

  <div class="flex-1-0-350px">
    <lib-app-transaction-country-selector
      [countryList]="sourceA$"
      (countryClicked)="onCountryClick($event)"
      [displayLabel]="'Paying'"
      [resetSelection]="resetSelection$"
      [selectedItemId]="sourceASelectedItemId$"
    ></lib-app-transaction-country-selector>

  </div>
  <div class="page-separator"></div>
  <div class="flex-1-0-350px">
    <lib-app-transaction-country-selector
      [componentDisabled]="!showReceiving"
      [countryList]="sourceB$"
      (countryClicked)="onCountryClick($event)"
      [displayLabel]="'Receiving'"
      [resetSelection]="resetSelection$"
      [selectedItemId]="sourceBSelectedItemId$"
    ></lib-app-transaction-country-selector>
  </div>
  <div class="page-separator"></div>
  <div class="flex-1-0-350px">
    <particle-tree-selector
      [title]="'Stream(s)'"
      [treeData]="streamData$"
      [componentDisabled]="!showStream"
      [itemViewerName]="itemViewerName"
      [quickSelections]="streamQuickSelectionsOptions$"
      (selectionChanged)="onStreamSelectionChanged($event)"
      (quickSelectionClicked)="onStreamQuickSelectionClick($event)"></particle-tree-selector>
  </div>
</div>

